import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nComponent } from './i18n.component';
import {MatMenuModule} from "@angular/material/menu";
@NgModule({
    declarations: [
        I18nComponent
    ],
    imports: [
        CommonModule,
        MatMenuModule
    ],

    exports: [
        I18nComponent
    ]
})
export class I18nModule { }

